export default {
	LOAD_WEBFORMS: 'LOAD_WEBFORMS'
};
